"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { cx } from "../internal/cx.js";
import { IconLoader } from "../internal/icons.js";
/** «Work in progress»: a spinning ring with a required label. */
export function Spinner({ label, size = "md", className }) {
    return _jsx("span", { className: cx("jui-spinner", size === "sm" && "jui-spinner--sm", className), role: "status", "aria-label": label, title: label, children: _jsx(IconLoader, { className: "jui-spin", small: size === "sm" }) });
}
